import React from 'react';
import { Container, Row, Col } from 'bootstrap-4-react';
import logo from '../images/logo.png';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import axios from 'axios';

class Footer extends React.Component
{
    constructor() {
        super();
        this.state = {
            email: ''
        }
        this.handleChange = this.handleChange.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
      }
      state={
        posted: '',
        message: '',
        email: '',
    }
    handleChange = event => {this.setState({ email: event.target.value })}

    handleSubmit(event) {
        event.preventDefault();
            console.log(this.state.email);
       axios.post('/moobifunapi/v1/newsletter/subscribe/emails/' + this.state.email)
        .then(response => {
            console.log(response);
            this.setState({
                posted: 'success',
                email: '',
                message: 'Thank you for subscribing to Moobifun!'
            });
        })
        .catch(fresponse => {
            this.setState({
                posted: 'error',
                message: "An error has occured please try again!"
            });
        
        });
    }
    render() {
       return (
        <footer>
            <Container>
                <Row>
                    <Col col="lg-2 12">
                        <div className="footer-logo">
                            <img src={logo}/>
                        </div>
                    </Col>
                    <Col col="lg-2 12">
                        <div className="footer-menu">
                            <h3>Company</h3>
                            <ul>
                                <li><Link to="/aboutus">About Us</Link></li>
                                <li><Link to="/team">Our Team</Link></li>
                                <li><Link to="/careers/">Careers</Link></li>
                                <li><Link to="/contact/">Contact Us</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col col="lg-2 12" >
                        <div className="footer-menu">
                            <h3>Solutions</h3>
                            <ul>
                                <li><Link to="/omni-channel/">Omnichannel</Link></li>
                                <li><Link to="/data-innovation">Data Innovation</Link></li>
                                <li><Link to="/data-analytics">Data Analytics</Link></li>
                                <li><Link to="/products/">Products</Link></li>
                                <li><Link to="/demographics/">Demographics</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col col="lg-2 12" >
                        <div className="footer-menu">
                            <h3>Case Studies</h3>
                            <ul>
                                <li><Link to="/case-studies/">Projects</Link></li>
                                <li><Link to="/presence/">Presence</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col col="lg-4 12" >
                        <div className="footer-menu">
                            <h3>Newsletter</h3>
                            <div className="newsletter-footer">
                                <form onSubmit={this.handleSubmit}>
                                    <input type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleChange}/>
                                    <input type="submit" value="Subscribe"/>
                                </form>
                                <p className={"message " + this.state.posted}>{this.state.message}</p>
                            </div>
                            <div className="footer-social">
                            <h3>Follow us!</h3>
                                <a href="https://www.facebook.com/Moobifun-442860459106525/" target="_blank" rel="noopener noreferrer" ><i className="fa fa-facebook-square"></i></a>
                                <a href="https://twitter.com/moobifun?lang=en" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a>
                                <a href="https://www.linkedin.com/company/moobifun/about/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
       );
    }
}
export default Footer;
